import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, FileUploadRes, SearchModel} from '@yasc/yasc-material-components';
import {ArticleResponse, ArticleUpdateReq,} from '../../../../contracts/v0/inventory/article.contracts';
import {ApiV0Inventory} from '../api.v0.inventory';

export class ApiV0Article {
    segment: string;

    constructor(v0: ApiV0Inventory, private rest: RestApiService) {
        this.segment = v0.segment + '/article';
    }

    list(): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.get<BaseCollectionModel<ArticleResponse>>(`${this.segment}/list`, ArticleResponse);
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<SearchModel, BaseCollectionModel<ArticleResponse>>(`${this.segment}/search`, ArticleResponse, searchModel);
    }

    detail(guid: string): Observable<ArticleResponse> {
        return this.rest.get(`${this.segment}/details/${guid}`, ArticleResponse);
    }

    create(createRequest: ArticleUpdateReq) {
        return this.rest.post<ArticleUpdateReq, ArticleResponse>(`${this.segment}/create`, ArticleResponse, createRequest);
    }

    update(guid: string, updateRequest: ArticleUpdateReq): Observable<ArticleResponse> {
        return this.rest.patch<ArticleUpdateReq, ArticleResponse>(`${this.segment}/update/${guid}`, ArticleResponse, updateRequest);
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`);
    }

    createList(createRequestList: ArticleUpdateReq[]): Observable<BaseCollectionModel<ArticleResponse>> { // PMP
        return this.rest.post<ArticleUpdateReq[], BaseCollectionModel<ArticleResponse>>(`${this.segment}/create`, ArticleResponse, createRequestList);
    }

    updateList(updateRequestList: ArticleUpdateReq[]): Observable<BaseCollectionModel<ArticleResponse>> { // PMP
        return this.rest.patch<ArticleUpdateReq[], BaseCollectionModel<ArticleResponse>>(`${this.segment}/update`, ArticleResponse, updateRequestList);
    }

    // https://stackoverflow.com/questions/21863326/delete-multiple-records-using-rest
    deleteList(guidList: string[]) { // PMP
        return this.rest.delete<string[]>(`${this.segment}/delete`, guidList);
    }

    // convenience functions for predefined, existing values
    modelCategorySelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/modelCategorySelectionList`);
    }

    // functions for handling json data
    importFromJsonData(fileUploadRes: FileUploadRes): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<{}, BaseCollectionModel<ArticleResponse>>(`${this.segment}/import/json/${fileUploadRes.id}`, ArticleResponse);
    }

    // exportToJsonData(guidList: string[]): Observable<BaseCollectionModel<ArticleResponse>> {
    //     return this.rest.post<{}, BaseCollectionModel<ArticleResponse>>(`${this.segment}/export/json`, {'guidList': guidList});
    // }

    // functions for handling xml data
    importFromXmlData(fileUploadRes: FileUploadRes): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<{}, BaseCollectionModel<ArticleResponse>>(`${this.segment}/import/xml/${fileUploadRes.id}`, ArticleResponse);
    }

    exportToXmlData(guidList: string[]): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<string[], BaseCollectionModel<ArticleResponse>>(`${this.segment}/export/xml`, ArticleResponse, guidList);
    }

    // functions for handling csv files
    importFromCsvData(fileUploadRes: FileUploadRes): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<{}, BaseCollectionModel<ArticleResponse>>(`${this.segment}/import/csv/${fileUploadRes.id}`, ArticleResponse);
    }

    // exportToCsvData(guidList: string[]): Observable<BaseCollectionModel<ArticleResponse>> {
    //     return this.rest.post<string[], BaseCollectionModel<ArticleResponse>>(`${this.segment}/export/csv`, guidList);
    // }

    // functions for handling excel data
    importFromExcelData(fileUploadRes: FileUploadRes): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<{}, BaseCollectionModel<ArticleResponse>>(`${this.segment}/import/excel/${fileUploadRes.id}`, ArticleResponse);
    }

    // exportToExcelData(guidList: string[]): Observable<BaseCollectionModel<ArticleResponse>> {
    //     return this.rest.post<string[], BaseCollectionModel<ArticleResponse>>(`${this.segment}/export/excel`, guidList);
    // }

    // functions for handling word data
    importFromWordData(fileUploadRes: FileUploadRes): Observable<BaseCollectionModel<ArticleResponse>> {
        return this.rest.post<{}, BaseCollectionModel<ArticleResponse>>(`${this.segment}/import/word/${fileUploadRes.id}`, ArticleResponse);
    }

    // exportToWordData(guidList: string[]): Observable<BaseCollectionModel<ArticleResponse>> {
    //     return this.rest.post<string[], BaseCollectionModel<ArticleResponse>>(`${this.segment}/export/word`, guidList);
    // }

}

